import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { trackIsEditingToggle } from '../../tracking';

import * as Styled from './edit-bar.styles';

type ToogleEditModeProps = {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
};
export const ToggleEditMode: FC<ToogleEditModeProps> = ({
  isEditing,
  setIsEditing,
}) => {
  const handleToggleEditMode = () => {
    setIsEditing(!isEditing);
    trackIsEditingToggle(!isEditing);
  };

  return (
    <Styled.Button
      variant={isEditing ? 'secondary' : 'primary'}
      size={'small'}
      onClick={handleToggleEditMode}
      data-testid={
        isEditing
          ? 'EP_EDIT_ACTION_SET_EDIT_MODE_OFF'
          : 'EP_EDIT_ACTION_SET_EDIT_MODE_ON'
      }
    >
      <FormattedMessage
        id={
          isEditing
            ? 'EP_EDIT_ACTION_SET_EDIT_MODE_OFF'
            : 'EP_EDIT_ACTION_SET_EDIT_MODE_ON'
        }
      />
    </Styled.Button>
  );
};
